import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Form,
  Space,
  Button,
  Drawer,
} from '@lockerpm/design';

import {
} from '@ant-design/icons';

import commonComponents from '../../../../../components/common';

import global from '../../../../../config/global';
import workspaceServices from '../../../../../services/workspace';

function FormData(props) {
  const { ItemInput } =commonComponents;
  const {
    visible = false,
    onClose = () => {},
    onReload = () => {},
  } = props
  const { t } = useTranslation()
  const selectedWorkspace = useSelector((state) => state.workspace.selectedWorkspace)

  const [form] = Form.useForm();
  const [callingAPI, setCallingAPI] = useState(false);
  const [wsMembers, setWsMembers] = useState([]);

  const usernames = Form.useWatch('usernames', form) || [];

  useEffect(() => {
    if (selectedWorkspace?.id) {
      fetchWsMembers()
    }
  }, [selectedWorkspace])

  useEffect(() => {
    form.setFieldsValue({
      usernames: []
    })
  }, [visible])

  const fetchWsMembers = () => {
    workspaceServices.members(selectedWorkspace?.id, { paging: 0 }).then((response) => {
      setWsMembers(response);
    }).catch(() => {
      setWsMembers([])
    })
  }

  const handleSave = async () => {
    form.validateFields().then(async () => {
      setCallingAPI(true);
      const members = usernames.map((u) => ({ username: u, role: global.constants.WS_MEMBER_ROLE.MEMBER }))
      await workspaceServices.create_multiple(selectedWorkspace.id, { members }).then(() => {
        onReload();
        onClose();
      }).catch((error) => {
        global.pushError(error)
      })
      setCallingAPI(false);
    })
  }

  const handleClose = () => {
    form.resetFields();
    onClose()
  }

  return (
    <div className={props.className}>
      <Drawer
        title={t('members.new')}
        placement="right"
        onClose={handleClose}
        open={visible}
        footer={
          <Space className='flex items-center justify-end'>
            <Button
              disabled={callingAPI}
              onClick={handleClose}
            >
              {t('button.cancel')}
            </Button>
            <Button
              type="primary"
              disabled={!usernames.length}
              loading={callingAPI}
              onClick={handleSave}
            >
              { t('button.add') } 
            </Button>
          </Space>
        }
      >
        <Form
          form={form}
          layout="vertical"
          labelAlign={'left'}
        >
          <Form.Item
            name={'usernames'}
            rules={[
              ({ }) => ({
                validator(_, value) {
                  const existedUsernames = value.filter((v) => wsMembers.find((m) => m.user?.email === v || m.email === v)) 
                  if (existedUsernames.length <= 0) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t('validation.existed', { name: t('common.username') })));
                },
              })
            ]}
            label={<div>
              <p className='font-bold'>{t('auth_pages.username')}</p>
              <span>{t('member.username_description')}</span>
            </div>}
          >
            <ItemInput
              type={'email'}
              items={wsMembers.map((m) => m.user?.email ||  m.email)}
              disabled={callingAPI}
            />
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
}

export default FormData;
